export default {
  categories: {
    list_of_categories: 'カテゴリ一覧',
    topic: 'トピック',
    topic_code: 'トピックコード',
    topicCode: 'トピックコード',
    parentCategory: '親カテゴリ',
    noParent: '親なし',
    create_a_new_category: '新しいカテゴリを作成',
    edit_category: 'カテゴリを編集',
    confirm_remove_category: 'カテゴリの削除を確認しますか？',
    categories_management: 'カテゴリ管理',
    search_placeholder: 'カテゴリを検索...',
    no_results: '結果が見つかりません',
    no_categories: 'カテゴリが見つかりません',
    parent: '親',
    confirm_delete: '削除の確認',
    delete_success: 'カテゴリを削除しました',
    delete_error: 'カテゴリの削除中にエラーが発生しました',
    create_success: 'カテゴリを作成しました',
    create_error: 'カテゴリの作成中にエラーが発生しました',
    update_success: 'カテゴリを更新しました',
    update_error: 'カテゴリの更新中にエラーが発生しました',
    save_error: 'カテゴリの保存中にエラーが発生しました',
    add_category: 'カテゴリを追加',
    enter_topic: 'トピックを入力',
    enter_topic_code: 'トピックコードを入力',
    select_parent: '親カテゴリを選択',
    no_parent: '親なし',
    label: 'ラベル',
    label_english: 'ラベル（英語）',
    code: 'コード',
    filter: 'フィルター',
    parent_category: '親カテゴリ',
    category: 'カテゴリ',
    edit_universe_category: 'ユニバースカテゴリを編集',
    add_universe_category: 'ユニバースカテゴリを追加',
    create_a_new_universe_category: '新しいユニバースカテゴリを作成',
    universe_categories_management: 'ユニバースカテゴリ管理',
    create_a_new_subcategory: '新しいサブカテゴリを作成',
    subcategories_management: 'サブカテゴリ管理',
    edit_subcategory: 'サブカテゴリを編集',
    create: '作成',
    select_parent_category: '親カテゴリを選択',
    type: 'タイプ',
    template_preview: 'テンプレートのプレビュー',
    template_one: 'テンプレート1',
    template_two: 'テンプレート2',
    template_three: 'テンプレート3',
    select_category: 'カテゴリを選択',
    one_or_more_categories: '1つ以上のカテゴリ',
    import_excel: 'Excelからインポート',
    import_template: 'テンプレートをダウンロード',
    import_loading: 'インポート中…',
    import_done: 'インポート完了',
    import_universes: 'ユニバース',
    import_categories: 'カテゴリ',
    import_subcategories: 'サブカテゴリ',
    import_created: '作成',
    import_existing: '既存',
    import_errors: 'エラーがあります。インポートされませんでした',
    import_row: '行',
    import_select_file: '.xlsx または .xls ファイルを選択してください',
    import_close: '閉じる',
  },
};
